import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { StockLevel } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class StockLevelRepository extends RepositoryBase<StockLevel> {
  protected readonly KEY_PATH = 'stock_level';
}
